/* Public-facing legal disclosure for the Trade Credit Insurance &
   Collections Authorisation buyers accept on signup. Linked from the buyer
   signup form so signing buyers can read the full text before agreeing. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function InsuranceLegal() {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    api.get("/insurance/v2/legal-disclosure")
      .then((r) => setDoc(r.data))
      .catch(() => setDoc(null));
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="text-xs text-foreground/55 hover:text-foreground inline-flex items-center gap-1.5 mb-8">
          <ArrowLeft className="w-3 h-3"/>Back to verqo
        </Link>

        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-foreground text-accent grid place-items-center">
            <ShieldCheck className="w-5 h-5"/>
          </div>
          <div className="text-[10px] mono uppercase tracking-[0.2em] text-foreground/55">Legal · verqo Wholesale OS</div>
        </div>
        <h1 className="display text-4xl tracking-tight mt-2">{doc?.title || "Trade Credit Insurance & Collections Authorisation"}</h1>
        <div className="text-[12px] text-foreground/55 mt-2">
          {doc?.version && <>v{doc.version} · </>}
          {doc?.effective_date && <>Effective {doc.effective_date}</>}
        </div>

        <div className="mt-8 prose prose-sm max-w-none text-foreground/80 whitespace-pre-line leading-relaxed" data-testid="ins-legal-body">
          {doc?.body || "Loading…"}
        </div>

        <div className="mt-12 rounded-2xl border border-border bg-secondary/30 p-5 text-[12.5px] text-foreground/70">
          <strong className="text-foreground">Plain-English summary:</strong> When you don't pay an invoice on time and the supplier insured it through verqo, an insurance company (Allianz Trade) takes over collections and pays the supplier. You still owe the money — to the insurer instead of the supplier. The insurer can also report you to credit bureaus and enforce the debt legally. We share invoice details with them so they can do this.
        </div>
      </div>
    </div>
  );
}
